/* eslint-disable global-require */
const customLocales = {};
const regex = /^.+?\/([\w]+)\.json$/i;

// `require` in every file except index.js from the current directory, then
// add their default export to module.exports based on their filename.
// eg dynamicMiddlewares["dynamicMiddleware"] = require("./dynamicMiddleware.js");
const req = require.context('.', true, /\.json$/);
req.keys().forEach(fileName => {
  const exportName = fileName.match(regex)[1];
  customLocales[exportName] = req(fileName);
});

export { customLocales };
